import React from "react";
import formStyles from "../../../formStyles";
import { withStyles, Button, CircularProgress } from "@material-ui/core";

const Action = ({
  onClose,
  classes,
  onConfirm,
  isCreateTerminalFlow,
  terminalUpdateInProgress,
  submitButtonLabel,
}) => {
  return (
    <div className={classes.actionContainer}>
      <Button
        variant="outlined"
        color="primary"
        size="medium"
        onClick={onClose}
        classes={{ root: classes.actionButton }}
        id="closeButton"
      >
        Close
      </Button>
      <Button
        variant="contained"
        color="primary"
        size="medium"
        type="submit"
        onClick={onConfirm}
        classes={{
          root: classes.actionButton,
          disabled: classes.actionButtonDisabled,
        }}
        id={
          isCreateTerminalFlow
            ? "addAccessibleTerminals"
            : "updateAccessibleTerminals"
        }
      >
        {terminalUpdateInProgress ? (
          <CircularProgress
            size={16}
            classes={{ root: classes.circularProgress }}
          />
        ) : (
          submitButtonLabel
        )}
      </Button>
    </div>
  );
};

export default withStyles(formStyles)(Action);
